import 'core-js/stable';
import 'classlist-polyfill';
// https://github.com/stefanpenner/es6-promise#auto-polyfill
import 'es6-promise/auto';
import 'formdata-polyfill';
import 'intersection-observer';
import './array-find';
import './array-findindex';
import './array-foreach';
import './array-from';
import './element-children';
import './element-closest';
import './object-assign';
import './string-includes';
import './window-customevent';
import './window-requestanimationframe';
